export default {"src":"/_next/static/image/public/images/medicine_home.4d26a9b3b46fdcf0dafc785b7279101c.svg","height":36,"width":36};